export default __webpack_public_path__ + "static/media/Cuprum-SemiBold.90148bdc.ttf";